import React from "react";
import axios from "axios";
import Bloodhound from 'bloodhound-js';
import 'typeahead.js';
import $ from "jquery";
import {
    getFromLocalStorage,
    removeNestedNullUndefined,
    strstr
} from './Utilities';

class SelectedBrand extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            "show": true
        };
    }

    handleClick = (obj) => {
        this.props.sendRemove(obj);
    }

    render(){
        if(this.state.show){
            return (
                <li className={"select2-selection__choice brand selected-brand brand-id-"+this.props.ID}  
                    data-brand-id={this.props.ID} title={this.props.Name}>
                    <span onClick={(e) => this.handleClick(this)} role="presentation">×</span> {this.props.Name}
                </li>
            );
        } else {
            return(<div></div>);
        }
    }
}

class ErrorMessage extends React.Component{
    render(){
        return <div className="error-message">{this.props.error}</div>
    }
}

class BrandList extends React.Component {
    static apiPromise = null; // Static variable to store API request promise
    static apiData = null; // Static variable to store resolved API data

    constructor(props){
        super(props);
        this.myRef = React.createRef();
        this.state = {
            "brands": null,
            "brandsLoaded": false,
            "selected": {},
            "selectedCount": 0,
            "error": false,
            "refreshToken": 0,
            "maxBrands": props.maxBrands,
            "status": props.status
        };
    }

    componentDidMount() {
        this.getData();

        const parent = this;//so we can use this as "parent" within bind event scope
        $(this.myRef.current).bind('typeahead:selected', function(selected, obj) {
            if(parent.props.page === "BrandsHolderPage"){
                parent.setHolderPageSelected(obj);
            } else if (parent.props.page === "SegmentPage"){
                parent.setSegmentBrand(obj);    
            } else {    
                parent.setSelected(obj);            
            }
        });  
        
        if(this.props.page !== "BrandsHolderPage" && this.props.page !== "SegmentPage") this.getSelected(); 
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(this.state.brands && !this.state.brandsLoaded) {
            this.setState({
                brandsLoaded: true
            });
            this.createTypeahead();          
        }   
    }

    createTypeahead(){
        var brands = new Bloodhound({
            local: this.state.brands,
            limit: 10,
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('Name'),
            queryTokenizer: Bloodhound.tokenizers.whitespace
        });
        brands.initialize();

        var options = {
            hint: true,
            highlight: true,
            minLength: 1
        };

        const source = {
            name: 'brands',
            displayKey: 'name',
            multiple: true,
            templates: {
                suggestion: function (data) {
                    return '<div class="brand" data-brand-id="'+data.ID+'">'+data.Name+'</div>';
                }
            },
            source: brands.ttAdapter()
        };

        //page specific options
        if(this.props.page === "SegmentsHolderPage" || this.props.page === "SegmentPage"){
            options.highlight = false;
            source.limit = 3;
        } 

        $(this.myRef.current).typeahead(options, source);

        if(this.props.page !== "BrandsHolderPage" && this.props.page !== "SegmentPage") this.getSelected(); 
    }

    getData(){
        if (BrandList.apiData) {
            // If data is already available, use it immediately
            this.formatData(BrandList.apiData);
            this.createTypeahead();
            return;
        }

        if (!BrandList.apiPromise) {
            BrandList.apiPromise = new Promise((resolve, reject) => {
                var url = "react/process?endpoint=brands&asList=true&orderBy=Name&turnoffdebug=1&IgnoreFilters=1";
                var cacheKey = $(".brandlistcachekey").data("brandlistcachekey");
                if(cacheKey) url += "&cacheKey="+cacheKey;
                resolve(axios.get(url).then((response) => response.data));
            });
        }

        BrandList.apiPromise.then((data) => {
            if (data) {
                BrandList.apiData = data;
                this.formatData(data);
            }
        });
    }

    formatData(data){
        var selected = this.state.selected
        var brandlist = data.items;

        //remove already selected
        $(selected).each(function(key, brand){
            $(brandlist).filter(function(index, obj){
                if(obj && brand.ID === parseInt(obj.ID)) delete brandlist[index];
                return obj;
            });
        });

        this.setState({
            brands: brandlist,
            count: data.totalSize
        });
    }

    setSelected(obj) {     
        var allSelected = this.state.selected;
        var maxBrands = this.state.maxBrands ? this.state.maxBrands : this.props.maxBrands;
        var currentCount = parseInt(this.state.selectedCount);

        if(currentCount < maxBrands){
            var newlySelected = {'ID': obj.ID, 'Name': obj.Name};
            allSelected[Object.keys(allSelected).length+1] = newlySelected;

            var brandlist = this.state.brands;
            $(brandlist).filter(function(index, brand){//remove selected from list
                if(brand && parseInt(brand.ID) === parseInt(newlySelected.ID)) delete brandlist[index];
                return brand;
            });

            this.props.onChange(removeNestedNullUndefined(allSelected));

            this.setState({
                "brands": brandlist,
                "selected": allSelected,
                "selectedCount": currentCount + 1,
                "error": false
            });

            //reset typeahead with selected brand removed
            $(this.myRef.current).typeahead('destroy');
            this.createTypeahead();

        } else {
            if(maxBrands > 1){
                var error = "You can select a maximum of "+maxBrands+" brands";
            } else {
                var error = "You can only select one brand";
            }
            this.setState({
                "error": error
            }); 
        }
    }

    setHolderPageSelected(obj){
        $('#brand-selector').typeahead('val', obj.Name);
        this.props.sendToPage(obj.Name);
    }

    getSelected(){
        // get existing selections on page load
        var filters = getFromLocalStorage("report_data");
        var alreadySelected = {};

        if(filters && Object.keys(filters).length > 0){
            if(filters.ChooseBrands){
                var brands = filters.ChooseBrands;
                // console.log(brands);
                if(Object.keys(brands).length > 0){
                   $(Object.values(brands)).each(function(key, obj){
                        alreadySelected[obj.ID] = {'ID': obj.ID, 'Name': obj.Name}
                   });
                }
            }
        }

        this.setState({
            "selected": Object.values(alreadySelected),
            "selectedCount": Object.keys(alreadySelected).length
        });
    }

    //segment page
    setSegmentBrand(obj){
        $("#brand-selector").attr("placeholder", "");
        $("#SegmentPageForm #BrandID").val(obj.ID);

        this.setState({
            "selected": [obj],
            "selectedCount": 1
        });
        $(this.myRef.current).attr("disabled", "disabled");
    }

    //triggered by SelectedBrand when removed
    removeSelected = (remove) => {
        if(this.props.page === "SegmentPage") {
            this.setSegmentBrand({});
            this.setState({
                "selected": {},
                "selectedCount": 0
            });
            $(this.myRef.current).removeAttr("disabled");
            return;
        }
        else var filters = getFromLocalStorage("report_data");

        var selected = {};

        if(Object.keys(filters).length > 0){
            if(filters.ChooseBrands){
                var brands = filters.ChooseBrands;
                if(Object.keys(brands).length > 0){
                   $(Object.values(brands)).each(function(key, obj){
                        if(obj.ID !== remove.props.ID) selected[obj.ID] = {'ID': obj.ID, 'Name': obj.Name}
                   });
                }
            }
        }     

        if(strstr(window.location.pathname, "reports")) this.props.onChange(removeNestedNullUndefined(selected));
        else window.ReportsCriteria.updateFilters("ChooseBrands", selected);
        
        this.setState({
            "selected": Object.values(selected),
            "selectedCount": Object.keys(selected).length
        });
    }

    render() {
        const selected = this.state.selected ? this.state.selected : {};
        const error = this.state.error;
        const parent = this;
        var placeholder = (this.props.page === "SegmentPage" && selected.length > 0) ? "" : "Start typing to look up brand...";

        if(Object.keys(selected).length !== 0){
            return(
                <div>
                    <input type="text" id="brand-selector" placeholder={placeholder} ref={this.myRef} style={this.props.inputStyle} />
                    <div className="selected-brands-holder">
                        <ErrorMessage error={error} />
                        {Object.entries(selected).map(function(obj, key) {
                           return <SelectedBrand key={key} ID={obj[1].ID} Name={obj[1].Name} sendRemove={parent.removeSelected.bind(this)} />;
                        })}
                    </div>
                </div>
            );
        } else {
            return(
                <div>
                    <input type="text" id="brand-selector" placeholder={placeholder} ref={this.myRef} style={this.props.inputStyle} />
                    <div className="react-loading" style={this.props.loaderStyle}></div>
                </div>    
            );
        }
    }
}

BrandList.defaultProps = {
    maxBrands: 5,
    inputStyle: {
        'width': '100%',
        'height': '32px',
        'margin': "-2px 0 0 0"
    },
    loaderStyle: {
        "height": "32px",
        "margin": "-31px 0 0 2px"
    }
};

export default BrandList;

